import { DialogContentText } from '@mui/material';
import { EnhancedDialog } from 'components/enhanced';
import { useTranslation } from 'react-i18next';

interface QuantityValidationConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const QuantityValidationConfirmationDialog = ({
  open,
  onClose,
  onConfirm
}: QuantityValidationConfirmationDialogProps) => {
  const { t } = useTranslation();

  return (
    <EnhancedDialog
      open={open}
      onSubmit={onConfirm}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      submitLabel={t('actions.confirm')}
      title={t('pages.purchase-requests.new.quantity-multiple-confirmation-title')}>
      <DialogContentText>
        {t('pages.purchase-requests.new.quantity-multiple-confirmation-text')}
      </DialogContentText>
    </EnhancedDialog>
  );
};

export default QuantityValidationConfirmationDialog;
